export default __webpack_public_path__ + "static/media/inputH.f586784f.png";